export default __webpack_public_path__ + "static/media/main_features_2.5aa1338e.webp";